import { Controller } from "@hotwired/stimulus"

// Toggles the `hidden` class on every panel target. Used to reveal an inline
// form (one panel) or swap a masked value for its full value (two panels).
export default class extends Controller {
  static targets = [ "panel" ]

  toggle() {
    this.panelTargets.forEach((panel) => panel.classList.toggle("hidden"))
  }
}
